var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLineas(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#6E6259",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-20 -420) translate(20 420)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4.511,
    cy: 4.511,
    r: 1.435
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.701 7.701c.852-.852 1.322-1.985 1.322-3.19C9.023 2.024 6.999 0 4.51 0 2.024 0 0 2.024 0 4.511c0 1.205.47 2.338 1.321 3.19l3.19 3.19 3.19-3.19zm-5.855-3.19c0-1.47 1.195-2.665 2.665-2.665S7.177 3.042 7.177 4.51c0 1.47-1.196 2.666-2.666 2.666S1.846 5.981 1.846 4.511zM17.717 13.079c-1.81 0-3.282 1.472-3.282 3.28 0 .877.342 1.701.961 2.321l2.32 2.32 2.32-2.32c.62-.62.962-1.444.962-2.32 0-1.81-1.472-3.281-3.281-3.281zM5.127 17.038c0-1.505 1.224-2.729 2.728-2.729h2.283c1.352 0 2.452-1.1 2.452-2.451 0-1.352-1.1-2.452-2.452-2.452H7.751v1.23h2.387c.674 0 1.222.548 1.222 1.222 0 .673-.548 1.22-1.222 1.22H7.856c-2.184 0-3.96 1.777-3.96 3.96s1.776 3.96 3.96 3.96h6.867v-1.23H7.856c-1.505 0-2.73-1.225-2.73-2.73z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineas);
export default __webpack_public_path__ + "static/media/lineas.882e8e64.svg";
export { ForwardRef as ReactComponent };